/* Collaborations : comportements de la page (onglets de preuves, barre d'ancres collante, format présélectionné, champs conditionnels, formulaire).
   Aucune dépendance. Même fichier dans la maquette (js/collab-ui.js) et dans le thème (assets/mi-collab.js).
   Maquette : le formulaire porte data-co-sim : validation puis confirmation, AUCUN envoi. Thème : envoi natif de {% form 'contact' %}.
   Délégation d'événements : la page peut être re-rendue (changement de langue) sans empiler les écouteurs. */
(function () {
  'use strict';
  if (window.__miCollabUi) { window.__miCollabUi(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  /* ---------- onglets de preuves ---------- */
  function setTab(tab) {
    var wrap = tab.closest('.co-tabs'); if (!wrap) return;
    var tabs = [].slice.call(wrap.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  function enableTabs() {
    [].forEach.call(document.querySelectorAll('.co-tabs'), function (wrap) {
      if (wrap.classList.contains('is-on')) return;
      wrap.classList.add('is-on');
      var first = wrap.querySelector('[role="tab"][aria-selected="true"]') || wrap.querySelector('[role="tab"]');
      if (first) setTab(first);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.co-tabs [role="tab"]');
    if (t) setTab(t);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.co-tabs [role="tab"]'); if (!t) return;
    var tabs = [].slice.call(t.closest('.co-tabs').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(t), n = null;
    if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') n = tabs[0];
    else if (e.key === 'End') n = tabs[tabs.length - 1];
    if (n) { e.preventDefault(); setTab(n); n.focus(); }
  });

  /* ---------- format présélectionné + champs conditionnels ---------- */
  function keyOf(o) { return o ? (o.getAttribute('data-cle') || o.value) : ''; }
  function applyType(sel) {
    var v = keyOf(sel.options[sel.selectedIndex]);
    [].forEach.call(document.querySelectorAll('[data-hide-for]'), function (el) {
      var list = el.getAttribute('data-hide-for').split(/\s+/);
      var hide = list.indexOf(v) !== -1;
      el.hidden = hide;
      [].forEach.call(el.querySelectorAll('input,textarea,select'), function (f) { f.disabled = hide; });
    });
    /* budget : obligatoire seulement pour les partenariats de marque et d'outils (contenu sponsorisé, outil/produit) */
    var bud = document.querySelector('[data-co-budget]');
    if (bud) {
      var need = v === 'sponsored' || v === 'tool';
      var inp = bud.querySelector('input'), opt = bud.querySelector('[data-co-budget-opt]'), hint = bud.querySelector('[data-co-budget-hint]');
      if (inp) inp.required = need;
      if (opt) opt.hidden = need;
      if (hint) hint.hidden = !need;
    }
  }
  var live = null, flashT = 0;
  function announce(sel) {
    var lab = sel.closest('label'), name = lab && lab.querySelector('span') ? lab.querySelector('span').textContent.trim() : '';
    if (!live || !live.isConnected) {
      live = document.createElement('div'); live.className = 'sr-only'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = (name ? name + ' : ' : '') + sel.options[sel.selectedIndex].text; }, 60);
  }
  function flash(sel) {
    var lab = sel.closest('.co-f'); if (!lab) return;
    lab.classList.add('is-preselected'); clearTimeout(flashT);
    flashT = setTimeout(function () { lab.classList.remove('is-preselected'); }, 2200);
  }
  /* présélectionne le type (clé), déclenche change (champs conditionnels), renvoie true si la clé existe */
  function selectType(cle, quiet) {
    var sel = document.querySelector('[data-co-type]'); if (!sel || !cle) return false;
    var idx = -1;
    [].forEach.call(sel.options, function (o, i) { if (!o.disabled && keyOf(o) === cle) idx = i; });
    if (idx < 0) return false;
    sel.selectedIndex = idx;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    if (!quiet) { flash(sel); announce(sel); }
    return true;
  }
  /* défilement jusqu'au formulaire : le titre reste sous l'en-tête fixe (scroll-margin-top de .co-sec), le champ type reste visible */
  function goToForm(sel) {
    var sec = document.getElementById('contact'); if (!sec) return;
    sec.scrollIntoView({ behavior: behavior, block: 'start' });
    setTimeout(function () { try { sel.focus({ preventScroll: true }); } catch (err) { sel.focus(); } }, reduce ? 0 : 450);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-co-format]'); if (!a) return;
    var k = a.getAttribute('data-co-format'), sel = document.querySelector('[data-co-type]');
    if (!sel || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    selectType(k);
    try { var u = new URLSearchParams(location.search); u.delete('format'); u.set('type', k); history.replaceState(null, '', '?' + u.toString() + '#contact'); } catch (err) {}
    goToForm(sel);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-co-type]')) applyType(e.target);
  });

  /* ---------- barre d'ancres collante : ancre active + fixation sous l'en-tête ---------- */
  var ticking = false;
  function navState() {
    ticking = false;
    var nav = document.querySelector('.co-nav'); if (!nav) return;
    var slot = nav.closest('.co-nav-slot');
    var hd = document.querySelector('.site-header'), hb = hd ? hd.getBoundingClientRect().bottom : 0;
    if (slot) {
      slot.style.minHeight = nav.offsetHeight + 'px';
      var on = slot.getBoundingClientRect().top <= Math.max(hb, 0);
      nav.classList.toggle('is-stuck', on); nav.style.top = on ? Math.max(hb, 0) + 'px' : '';
    }
    var links = [].slice.call(nav.querySelectorAll('a'));
    var off = (hd ? hd.offsetHeight : 64) + nav.offsetHeight + Math.round(window.innerHeight * 0.3), idx = -1;
    links.forEach(function (a, i) {
      var s = document.querySelector(a.getAttribute('href'));
      if (s && s.getBoundingClientRect().top <= off) idx = i;
    });
    links.forEach(function (a, i) { if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    var cur = links[idx], tr = nav.querySelector('.co-nav__track');
    if (cur && tr && tr.scrollWidth > tr.clientWidth && nav.dataset.cur !== String(idx)) {
      nav.dataset.cur = String(idx);
      tr.scrollTo({ left: cur.offsetLeft - (tr.clientWidth - cur.offsetWidth) / 2, behavior: behavior });
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(navState); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- formulaire (maquette : simulation, aucun envoi) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-co-sim]'); if (!form) return;
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }
    form.hidden = true;
    var ok = document.querySelector('[data-co-ok]');
    if (ok) { ok.hidden = false; ok.focus(); }
  });

  /* ---------- cartes de formats : accordéon sur mobile, ouvertes (statiques) sur écran large ---------- */
  var mq = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : null;
  function cards() {
    [].forEach.call(document.querySelectorAll('.co-card'), function (d) {
      var wide = !!(mq && mq.matches);
      d.classList.toggle('is-static', wide);
      if (wide) d.open = true; else if (d.dataset.wide === '1') d.open = false;
      d.dataset.wide = wide ? '1' : '0';
      var m = d.querySelector('.co-more');
      if (m) { m.classList.toggle('is-static', !wide); if (!wide) m.open = true; else if (m.dataset.wide !== '1') m.open = false; m.dataset.wide = wide ? '1' : '0'; }
    });
  }
  document.addEventListener('click', function (e) { var s = e.target.closest && e.target.closest('.co-card.is-static > summary'); if (s) e.preventDefault(); });
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', cards); else if (mq.addListener) mq.addListener(cards); }


  /* ---------- chiffres clés : comptage animé jusqu'à la valeur exacte (une seule fois, à l'apparition) ---------- */
  function fmtNum(n, dec, comma) { var s = n.toFixed(dec); return comma ? s.replace('.', ',') : s; }
  function countUp() {
    var items = document.querySelectorAll('.co-stat b:not([data-counted])'); if (!items.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } });
    }, { threshold: 0.4 }) : null;
    [].forEach.call(items, function (el) {
      el.setAttribute('data-counted', '1');
      var txt = el.textContent.trim(), m = txt.match(/^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m || reduce || !io) return;
      el.setAttribute('aria-label', txt);
      el._c = { pre: m[1], num: parseFloat(m[2].replace(',', '.')), dec: (m[2].split(/[.,]/)[1] || '').length, comma: m[2].indexOf(',') > -1, suf: m[3], final: txt };
      el.textContent = el._c.pre + fmtNum(0, el._c.dec, el._c.comma) + el._c.suf;
      io.observe(el);
    });
    function run(el) {
      var c = el._c; if (!c) return; var t0 = null, dur = 1700;
      function step(ts) {
        if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 4);
        el.textContent = p < 1 ? c.pre + fmtNum(c.num * e, c.dec, c.comma) + c.suf : c.final;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
  }
  /* ---------- bandeau des marques : défilement continu (WCAG 2.2.2 : bouton Pause/Lecture, pause au survol et au focus) ----------
     Sans JS ou avec prefers-reduced-motion : grille statique. La liste <ul> d'origine reste lue par les lecteurs d'écran ; la copie est aria-hidden. */
  function setPause(btn, paused) {
    var sec = btn.closest('.co-brands'); if (!sec) return;
    sec.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-a-play' : 'data-a-pause') || '');
    var t = btn.querySelector('[data-co-pause-t]'); if (t) t.textContent = btn.getAttribute(paused ? 'data-l-play' : 'data-l-pause') || '';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-co-pause]');
    if (b) setPause(b, b.getAttribute('aria-pressed') !== 'true');
  });
  function brands() {
    if (reduce) return;
    [].forEach.call(document.querySelectorAll('.co-brands'), function (sec) {
      var view = sec.querySelector('[data-co-marquee]'), track = view && view.querySelector('.co-brands__track');
      if (!track || sec.classList.contains('is-marquee')) return;
      var ul = track.querySelector('.co-brands__list'); if (!ul) return;
      var copy = ul.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true'); copy.removeAttribute('role');
      [].forEach.call(copy.querySelectorAll('img'), function (i) { i.alt = ''; i.removeAttribute('loading'); });
      track.appendChild(copy);
      sec.classList.add('is-marquee');
      var btn = sec.querySelector('[data-co-pause]'); if (btn) { btn.hidden = false; setPause(btn, false); }
      var w = ul.scrollWidth || 1800;
      track.style.setProperty('--co-dur', Math.max(40, Math.min(60, Math.round(w / 45))) + 's');
      /* pilotage à la souris et au doigt : glisser, molette horizontale, flèches du clavier ; le défilement automatique continue ensuite (pause : bouton, survol, focus) */
      track.style.animation = 'none'; sec.classList.add('is-js'); view.setAttribute('tabindex', '0'); view.setAttribute('role', 'group');
      [].forEach.call(sec.querySelectorAll('img'), function (i) { i.draggable = false; });
      var x = 0, last = null, drag = null, vel = 0, hover = false, seen = true;
      var dur = Math.max(40, Math.min(60, Math.round(w / 45)));
      function half() { return ul.offsetWidth || w; }
      function wrapX() { var h = half(); if (h < 1) return; while (x <= -h) x += h; while (x > 0) x -= h; }
      function frame(ts) {
        requestAnimationFrame(frame);
        if (last === null) last = ts; var dt = Math.min(ts - last, 64) / 1000; last = ts;
        if (!seen || document.hidden) return;
        var paused = sec.classList.contains('is-paused') || hover || drag || sec.matches(':has(:focus-visible)');
        if (!paused) x -= (half() / dur) * dt;
        if (!drag && Math.abs(vel) > 0.05) { x += vel; vel *= 0.94; }
        wrapX(); track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(view);
      view.addEventListener('mouseenter', function () { hover = true; }); view.addEventListener('mouseleave', function () { hover = false; });
      view.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; drag = { x: e.clientX }; vel = 0; try { view.setPointerCapture(e.pointerId); } catch (err) {} sec.classList.add('is-drag'); });
      view.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - drag.x; drag.x = e.clientX; x += dx; vel = dx; });
      var endDrag = function () { drag = null; sec.classList.remove('is-drag'); };
      view.addEventListener('pointerup', endDrag); view.addEventListener('pointercancel', endDrag);
      view.addEventListener('wheel', function (e) { var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0); if (d) { e.preventDefault(); x -= d; } }, { passive: false });
      view.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { x += 140; e.preventDefault(); } else if (e.key === 'ArrowRight') { x -= 140; e.preventDefault(); } });
      requestAnimationFrame(frame);
    });
  }
  function affModal() {
    if (window.__miAffModal) return; window.__miAffModal = true;
    var box = null, opener = null, prevOverflow = '';
    function close() {
      if (!box) return;
      document.removeEventListener('keydown', onKey, true);
      box.parentNode && box.parentNode.removeChild(box); box = null;
      document.body.style.overflow = prevOverflow;
      if (opener && opener.focus) opener.focus(); opener = null;
    }
    function onKey(e) {
      if (!box) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
      else if (e.key === 'Tab') { e.preventDefault(); box.querySelector('.co-modal__x').focus(); }
    }
    function open(btn) {
      var alt = btn.getAttribute('data-aff-alt') || '';
      opener = btn;
      box = document.createElement('div');
      box.className = 'co-modal'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', alt);
      var x = document.createElement('button'); x.type = 'button'; x.className = 'co-modal__x'; x.setAttribute('aria-label', btn.getAttribute('data-aff-close') || 'Close');
      x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      var img = document.createElement('img'); img.src = btn.getAttribute('data-aff-big'); img.alt = alt; img.decoding = 'async';
      box.appendChild(x); box.appendChild(img);
      box.addEventListener('click', function (e) { if (e.target !== img) close(); });
      prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      document.body.appendChild(box);
      document.addEventListener('keydown', onKey, true);
      x.focus();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-aff-big]') : null;
      if (b) { e.preventDefault(); open(b); }
    });
  }
  function init() {
    affModal(); enableTabs(); cards(); countUp(); brands();
    var sel = document.querySelector('[data-co-type]');
    if (sel) {
      applyType(sel);
      try {
        var qs = new URLSearchParams(location.search), q = qs.get('type') || qs.get('format');
        if (q && !sel.dataset.coPre && selectType(q, true)) {
          sel.dataset.coPre = '1';
          if (location.hash === '#contact') setTimeout(function () { flash(sel); announce(sel); }, 400);
        }
      } catch (err) {}
    }
    onScroll();
  }
  window.__miCollabUi = init;
  document.addEventListener('mi:co-rendered', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
